export default __webpack_public_path__ + "static/media/Small-Header-Edit-1.3b2537e4.jpg";